export function MenuContainer({ children }: { children: React.ReactNode }) {
    return (
        <div className="bg-white shadow-lg border border-gray-300 rounded-[6px] p-2 z-50 w-[300px]">
            {children}
        </div>
    );
}
